// ============================================================
//  ALTIMO Medical Center — ClinicaMedica.jsx
//  Módulo Clínico / Médico
//  Formularios: Evolución médica, Órdenes médico,
//               Control médicos tratantes, Chequeo previo QX
// ============================================================
import React, { useState } from 'react';
import Formularios  from './Formularios';
import ExpedientePaciente from './ExpedientePaciente';

const TABS = [
  { id:'formularios', label:'📋 Formularios Clínicos',  color:'#185FA5' },
  { id:'expediente',  label:'📂 Expedientes',           color:'#1B2A5E' },
];

export default function ClinicaMedica({ usuario, onVerCuenta, onAbrirFormulario }) {
  const [tab, setTab] = useState('formularios');
  const activo = TABS.find(t => t.id === tab) || TABS[0];

  return (
    <div style={{ fontFamily:'Segoe UI, sans-serif' }}>
      {/* Header módulo */}
      <div style={{ background:'linear-gradient(135deg,#185FA5,#1B2A5E)', padding:'16px 24px 0', display:'flex', alignItems:'flex-end', gap:'0' }}>
        <div style={{ flex:1, paddingBottom:'12px' }}>
          <div style={{ fontSize:'19px', fontWeight:'800', color:'#fff', marginBottom:'2px' }}>
            🩺 Módulo Clínico / Médico
          </div>
          <div style={{ fontSize:'12px', color:'rgba(255,255,255,.75)' }}>
            Evolución médica · Órdenes · Control de tratantes · Chequeo previo quirúrgico
          </div>
        </div>
        {/* Tabs */}
        <div style={{ display:'flex', gap:'2px' }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{ padding:'9px 22px', border:'none', cursor:'pointer', fontSize:'13px', fontWeight:'700',
                borderRadius:'8px 8px 0 0', fontFamily:'inherit', transition:'all .15s',
                background: tab === t.id ? '#fff' : 'rgba(255,255,255,.15)',
                color:      tab === t.id ? t.color : '#fff',
                boxShadow:  tab === t.id ? '0 -2px 8px rgba(0,0,0,.12)' : 'none',
              }}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Contenido */}
      {tab === 'formularios' && (
        <Formularios usuario={usuario} areaFiltro="clinico" />
      )}
      {tab === 'expediente' && (
        <ExpedientePaciente
          usuario={usuario}
          onVerCuenta={onVerCuenta}
          onAbrirFormulario={onAbrirFormulario}
        />
      )}
    </div>
  );
}
